import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    uploadImage(ctx, formData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/misc/upload', formData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateContent(ctx, data) {
      return new Promise((resolve, reject) => {
        axios
          .put(data.url, data.body)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchAboutUs(ctx, queryParams) {
      let lang = (queryParams.lang == undefined) ? 'en' : queryParams.lang;
      return new Promise((resolve, reject) => {
        axios
          .get(`/about-us/${queryParams.id}?lang=${lang}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchContactUs(ctx, queryParams) {
      let lang = (queryParams.lang == undefined) ? 'en' : queryParams.lang;
      return new Promise((resolve, reject) => {
        axios
          .get(`/pages/contact-us?lang=${lang}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * EVENTS
     * =======================
     */
    fetchEvents(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/events`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchEvent(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/events/${queryParams.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addEvent(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/events', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/events/${userData.id}`, userData.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteEvent(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchEventType(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/misc/types`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchEventBookings(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/events/bookings`, {params: queryParams})
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * FaQ
     * =======================
     */
    fetchFAQs(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/faqs`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchFAQ(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/faqs/${queryParams.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addFAQ(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/faqs', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFAQ(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/faqs/${userData.id}`, userData.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFAQ(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/faqs/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchFAQCategory(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/misc/categories`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * Pages
     * =======================
     */
    fetchPages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        let lang = (queryParams.lang == undefined) ? 'en' : queryParams.lang;
        axios
          .get(`/pages/${queryParams.menu}?lang=${lang}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    updatePages(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/pages/${queryParams.menu}`, queryParams.data)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * TESTIMONY
     * =======================
     */
    fetchTestimonies(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/testimonies`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchTestimony(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/testimonies/${queryParams.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addTestimony(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/testimonies', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateTestimony(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/testimonies/${userData.id}`, userData.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteTestimony(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/testimonies/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * ARTICLES
     * =======================
     */
    fetchArticles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/articles`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchArticle(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/articles/${queryParams.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addArticle(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/articles', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateArticle(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/articles/${userData.id}`, userData.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteArticle(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/articles/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    /*
     * =======================
     * FOOTERS
     * =======================
     */
    fetchFooters(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/footers`, { params: queryParams })
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    fetchFooter(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/footers/${queryParams.id}`)
          .then(response => {
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    addFooter(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('/footers', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateFooter(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/footers/${userData.id}`, userData.data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteFooter(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/footers/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
